import $ from "jquery";

$(document).on('click', '.orders\\/view__pay-button', function(event) {
	event.preventDefault();

	let order = $(this).closest('.orders\\/view');
	let stripe = Stripe(_config.stripe.key);

	stripe.redirectToCheckout({
		sessionId: order.attr('data-stripe-checkout-session-id'),
	}).then(function (result) {
	});
});
